import React from 'react'
import rollOverIcon from './assets/roll-over.svg'

function RollOverIcon() {
  return <img alt="" aria-hidden className="block h-6 w-6" src={rollOverIcon} />
}

export default RollOverIcon
